import { localeNames } from 'common/constants/localeTypes'
import {
  AutomationRuleActionsEnum,
  CommonActionType,
} from 'src/editor/shared/types/automation-rules/actions-types'

export const getAutomationRuleActionIdAndLabel = <
  Action extends CommonActionType,
>(
  action: Action,
) => {
  switch (action.type) {
    case AutomationRuleActionsEnum.add_tag:
    case AutomationRuleActionsEnum.remove_tag:
      return { id: action.tag.id, label: action.tag.name }
    case AutomationRuleActionsEnum.subscribe_to_campaign:
    case AutomationRuleActionsEnum.unsubscribe_from_campaign:
      return { id: action.campaign.id, label: action.campaign.name }
    case AutomationRuleActionsEnum.send_email:
      return { id: action.systemeEmail.id, label: action.systemeEmail.subject }
    case AutomationRuleActionsEnum.send_email_to_specific_address:
      return {
        id: action.emailMessageWithRecipient.id,
        label: action.emailMessageWithRecipient.mailing?.currentEmail?.subject,
      }
    case AutomationRuleActionsEnum.enroll_in_course:
    case AutomationRuleActionsEnum.revoke_access_to_course:
      return { id: action.course.id, label: action.course.name }
    case AutomationRuleActionsEnum.revoke_access_to_course_bundle:
    case AutomationRuleActionsEnum.enroll_in_course_bundle:
      return { id: action.courseBundle?.id, label: action.courseBundle?.name }
    case AutomationRuleActionsEnum.send_webhook:
      return { id: action.webhookUrl, label: action.webhookUrl }
    case AutomationRuleActionsEnum.grant_access_to_community:
    case AutomationRuleActionsEnum.revoke_access_to_community:
      return { id: action.community.id, label: action.community.name }
    case AutomationRuleActionsEnum.create_user:
      return {
        id: action.locale,
        label: action.locale && localeNames[action.locale],
      }
  }
}
